import { BaseModel } from './base.model';
import { HeaderDefaultItemModel } from './header-default-item.model';
import { HeaderItemModel } from './header-item.model';
import { HeaderQRCodeModel } from './header_qrcode.model';

export class HeaderDefaultModel extends BaseModel {
    name: string;
    checklist_id: number;
    qrcode?: HeaderQRCodeModel
    qrcode_id: number;
    headerDefaultItems: HeaderDefaultItemModel[];

    constructor(checklist_id?: number) {
        super();
        this.checklist_id = checklist_id;
        this.headerDefaultItems = [];
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/header-default.model.ts